import type { ICellRendererParams } from 'ag-grid-enterprise';

function TotalCellRenderer<TData = Record<string, unknown>, TContext = unknown>({
  node,
  value,
}: ICellRendererParams<TData, unknown, TContext>) {
  const isRootLevel = node.level === -1;

  return isRootLevel ? 'Total' : value;
}

export default TotalCellRenderer;
